// export const AWS = "https://fago.s3.ap-south-1.amazonaws.com/";
export const AWS = "https://fago-development.s3.ap-south-1.amazonaws.com/";
// export const ENDPOINT = "http://localhost:5000";
export const ENDPOINT = "https://dev.alsaalimintl.com";
